import { Directive, ElementRef, HostListener } from '@angular/core';
import { CommonConstant } from '../constants/common.constants';

@Directive({
  selector: '[plainNumbers]',
})
export class PlainNumbersDirective {
  private regex = new RegExp(CommonConstant.REGEX_PLAIN_NUMBER);
  private specialKeys = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
  ];

  constructor(private el: ElementRef) {}
  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    const current: string = this.el.nativeElement.value;
    const next: string = current.concat(event.key);
    if ((!event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey) && next && !String(next).match(this.regex)) {
      event.preventDefault();
      let targetValue = event.target['value'];
      targetValue = targetValue ? targetValue.replace(/\D/g,'') : targetValue;
      this.el.nativeElement.value = targetValue;
      return;
    }
  }

  @HostListener('keyup', ['$event']) onKeyUp(event: KeyboardEvent) {
    let targetValue = event.target['value'];
    if (!String(targetValue).match(this.regex)) {
      targetValue = targetValue ? targetValue.replace(/\D/g,'') : targetValue;
      this.el.nativeElement.value = targetValue;
    }
  }
}
